import request from '../request';
import { apiUrl } from '../api-url';


export default {

  // 提交咨询意见
  submitIssue(data) {
    return request({
      method: 'post',
      url: apiUrl.submitIssue,
      data,
    });
  },
};
